export default __webpack_public_path__ + "images/bgpk3.51b196d.jpg";